import React, { useRef } from "react";
import Select from "react-select";
import locList from "../../../../../assets/static/Locations.json";

function LocSelector({  loc, setLoc }) {
  const options = useRef(
    Object.values(locList).map((tag) => ({ value: tag, label: tag }))
  );

  return (
    <Select
      placeholder="Select State/UTs"
      value={loc} 
      name="state"
      isClearable={true}
      onChange={(newValue) => setLoc(newValue)}
      options={options.current}
    />
  );
}

LocSelector.defaultProps = {
};

export default LocSelector;
